import React from "react";
import AvgWeeklyDropdown from "./components/AvgWeeklyDropdown";

export default class JoinUsForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      blured: []
    };
  }
  handleOnBlur = input => {
    let { blured } = this.state;
    if (!blured.includes(input)) {
      blured.push(input);
    }
  };
  handleShowError = input => {
    const { blured } = this.state;
    return blured.includes(input);
  };
  closeJoinUs = () => {
    const { onClose } = this.props;
    if (onClose) {
      onClose({ status: "joinUs" });
    } else {
      window.location.href = "/";
    }
  };
  render() {
    const {
      onChange,
      restaurantName,
      restaurantAddress,
      contactName,
      contactNumber,
      position,
      businessName,
      email,
      avgWeeklyOrders,
      handleSubmit,
      active,
      formErrors
    } = this.props;
    return (
      <div>
        <div className="modal-bg" />
        <div className="modal">
          <div className="sign-page">
            {/* Header */}
            <div className="head-general with-back">
              <a href="javascript: void(0)" className="back" />
              <h4>Join the Local eCommunity</h4>
              <a
                href="javascript: void(0)"
                onClick={this.closeJoinUs}
                className="close"
              >
                <i className="icon icon-close" />
              </a>
            </div>
            {/* Header */}

            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div
                      className={`form-group ${(this.handleShowError(
                        "contactName"
                      ) &&
                        formErrors &&
                        formErrors["contactName"] &&
                        "error") ||
                        ""}`}
                    >
                      <input
                        id="contactName"
                        onBlur={() => this.handleOnBlur("contactName")}
                        className="form-input"
                        autoCapitalize="none"
                        autoComplete="none"
                        value={contactName}
                        type="text"
                        placeholder="Contact Name"
                        onChange={e => onChange(e)}
                      />
                      <span>
                        {(this.handleShowError("contactName") &&
                          formErrors &&
                          formErrors["contactName"] &&
                          formErrors["contactName"]) ||
                          ""}
                      </span>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div
                      className={`form-group ${(this.handleShowError(
                        "position"
                      ) &&
                        formErrors &&
                        formErrors["position"] &&
                        "error") ||
                        ""}`}
                    >
                      <input
                        id="position"
                        onBlur={() => this.handleOnBlur("position")}
                        className="form-input"
                        autoCapitalize="none"
                        autoComplete="none"
                        value={position}
                        type="text"
                        placeholder="Position"
                        onChange={e => onChange(e)}
                      />
                      <span>
                        {(this.handleShowError("position") &&
                          formErrors &&
                          formErrors["position"] &&
                          formErrors["position"]) ||
                          ""}
                      </span>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div
                      className={`form-group ${(this.handleShowError(
                        "contactNumber"
                      ) &&
                        formErrors &&
                        formErrors["contactNumber"] &&
                        "error") ||
                        ""}`}
                    >
                      <input
                        id="contactNumber"
                        onBlur={() => this.handleOnBlur("contactNumber")}
                        className="form-input"
                        value={contactNumber}
                        autoComplete="none"
                        type="tel"
                        placeholder="Contact Number"
                        onChange={e => onChange(e)}
                      />
                      <span>
                        {(this.handleShowError("contactNumber") &&
                          formErrors &&
                          formErrors["contactNumber"] &&
                          formErrors["contactNumber"]) ||
                          ""}
                      </span>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div
                      className={`form-group ${(this.handleShowError("email") &&
                        formErrors &&
                        formErrors["email"] &&
                        "error") ||
                        ""}`}
                    >
                      <input
                        id="email"
                        onBlur={() => this.handleOnBlur("email")}
                        className="form-input"
                        autoComplete="email"
                        value={email}
                        type="email"
                        autoCapitalize="none"
                        placeholder="E-mail Address"
                        onChange={e => onChange(e)}
                      />
                      <span>
                        {(this.handleShowError("email") &&
                          formErrors &&
                          formErrors["email"] &&
                          formErrors["email"]) ||
                          ""}
                      </span>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div
                      className={`form-group ${(this.handleShowError(
                        "restaurantName"
                      ) &&
                        formErrors &&
                        formErrors["restaurantName"] &&
                        "error") ||
                        ""}`}
                    >
                      <input
                        id="restaurantName"
                        onBlur={() => this.handleOnBlur("restaurantName")}
                        className="form-input"
                        autoComplete="none"
                        value={restaurantName}
                        type="text"
                        placeholder="Business Trading Name"
                        onChange={e => onChange(e)}
                      />
                      <span>
                        {(this.handleShowError("restaurantName") &&
                          formErrors &&
                          formErrors["restaurantName"] &&
                          formErrors["restaurantName"]) ||
                          ""}
                      </span>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div
                      className={`form-group ${(this.handleShowError(
                        "businessName"
                      ) &&
                        formErrors &&
                        formErrors["businessName"] &&
                        "error") ||
                        ""}`}
                    >
                      <input
                        id="businessName"
                        onBlur={() => this.handleOnBlur("businessName")}
                        className="form-input"
                        autoComplete="none"
                        value={businessName}
                        type="text"
                        placeholder="Registered Business Name"
                        onChange={e => onChange(e)}
                      />
                      <span>
                        {(this.handleShowError("businessName") &&
                          formErrors &&
                          formErrors["businessName"] &&
                          formErrors["businessName"]) ||
                          ""}
                      </span>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div
                      className={`form-group ${(this.handleShowError(
                        "restaurantAddress"
                      ) &&
                        formErrors &&
                        formErrors["restaurantAddress"] &&
                        "error") ||
                        ""}`}
                    >
                      <input
                        id="restaurantAddress"
                        onBlur={() => this.handleOnBlur("restaurantAddress")}
                        className="form-input"
                        value={restaurantAddress}
                        autoComplete="none"
                        autoCapitalize="none"
                        type="text"
                        placeholder=" Trading Address"
                        onChange={e => onChange(e)}
                      />
                      <span>
                        {(this.handleShowError("restaurantAddress") &&
                          formErrors &&
                          formErrors["restaurantAddress"] &&
                          formErrors["restaurantAddress"]) ||
                          ""}
                      </span>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div
                      className={`form-group ${(this.handleShowError(
                        "avgWeeklyOrders"
                      ) &&
                        formErrors &&
                        formErrors["avgWeeklyOrders"] &&
                        "error") ||
                        ""}`}
                    >
                      <AvgWeeklyDropdown
                        onSelectItem={onChange}
                        avgWeeklyOrders={avgWeeklyOrders}
                      />
                      <span>
                        {(this.handleShowError("avgWeeklyOrders") &&
                          formErrors &&
                          formErrors["avgWeeklyOrders"] &&
                          formErrors["avgWeeklyOrders"]) ||
                          ""}
                      </span>
                    </div>
                  </div>
                </div>
                {/* .row */}
                <div className="">
                  <button
                    className={`btn btn-sign join-us-button ${(active &&
                      "active") ||
                      ""}`}
                    type="submit"
                    disabled={!active}
                  >
                    <span>Submit</span>
                  </button>
                </div>
              </form>
            </div>
            {/* .modal-body */}
          </div>{" "}
          {/* .sign-page */}
        </div>{" "}
        {/* .modal */}
      </div>
    );
  }
}
